const USER_PUBLIC_PROFILE_LOAD_SUCCESS = 'USER_PUBLIC_PROFILE_LOAD_SUCCESS';

const USER_PUBLIC_PROFILE_CUSTOMER_LOAD_URL = '/user/public-profile/customer';
const USER_PUBLIC_PROFILE_OWNER_LOAD_URL = '/user/public-profile/owner';

const USER_PUBLIC_PROFILE_URL = '/user/public-profile/:type/:id';

const USER_PUBLIC_PROFILE_TYPE_CUSTOMER = 'customer';
const USER_PUBLIC_PROFILE_TYPE_OWNER = 'owner';

const REDUCER_USER_PUBLIC_PROFILE_NAME = 'reducerUserPublicProfile';

export {
  USER_PUBLIC_PROFILE_LOAD_SUCCESS,

  USER_PUBLIC_PROFILE_CUSTOMER_LOAD_URL,
  USER_PUBLIC_PROFILE_OWNER_LOAD_URL,

  USER_PUBLIC_PROFILE_TYPE_CUSTOMER,
  USER_PUBLIC_PROFILE_TYPE_OWNER,

  USER_PUBLIC_PROFILE_URL,

  REDUCER_USER_PUBLIC_PROFILE_NAME,
};
